import script from "./MapLegend.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapLegend.vue?vue&type=script&setup=true&lang=ts"

import "./MapLegend.vue?vue&type=style&index=0&id=926248c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-926248c0"]])

export default __exports__